import { render, staticRenderFns } from "./PPagination.vue?vue&type=template&id=78d5febe&scoped=true"
import script from "./PPagination.vue?vue&type=script&lang=ts"
export * from "./PPagination.vue?vue&type=script&lang=ts"
import style0 from "./PPagination.vue?vue&type=style&index=0&id=78d5febe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d5febe",
  null
  
)

export default component.exports